function priceFormat(price) {
  return (price != null ? price : 0).toLocaleString('nl-NL', {
    currency: 'EUR',
    style: 'currency'
  });
}

function savedShoppingCartTemplate(data, cartName, cartDate, noPrice = false) {
  const { identifier, carts, totalShippingCost, subtotal } = data;
  const { items } = carts[0];
  const totalPrice = priceFormat(subtotal - totalShippingCost.currentPriceInclVat);

  // prettier-ignore
  const html = `
        <div class="panel panel-default">
            <div class="panel-heading " style="position: relative; cursor: pointer;" data-toggle="collapse" data-parent="#accordion" role="tab" id="${identifier}" aria-expanded="false" data-target="#collapse-${identifier}" data-orderId="${identifier}">

            <div class="row">
                    <div class="col-xs-12 col-md-6">
                        ${cartName}
                    </div>
                    <div class="col-xs-12 col-md-3">
                    ${cartDate}
                    </div>
                    ${!noPrice ? `<div class="col-xs-12 col-md-3">
                    ${totalPrice}
                    </div>` : ''}
                    <div style="text-align: right; position: absolute;right: 10px; top: 50%; transform: translateY(-50%);">
                        <span class="caret"></span>
                    </div>
</div>
            </div>
            <div id="collapse-${identifier}" class="panel-collapse collapse" role="tabpanel" aria-labelledby="${identifier}">
                <div class="panel-body js-all-orders">
                    <div class="row hidden-xs c-order-history__header">
                        <div class="col-sm-8">Product</div>
                        <div class="col-sm-2">Aantal</div>
                        ${!noPrice ? `<div class="col-sm-2">Prijs</div>`: ''}
                    </div>

                    ${items.map((product) =>{
                    const isDeleted = product.result.errors.length > 0;
                    return `
                    <div class="row c-order-history__item ${isDeleted ? 'c-order-history__item--deleted' : ''}">
                        <div class="col-sm-8">
                            <div class="o-flag">
                                <div class="c-searchform__thumb o-flag__img">
                                    <img src="/content/products/${product.image}?width=60&height=60&anchor=center&background=white" class="img-responsive" alt="${product.description}">
                                </div>
                                <div class="o-flag__body">
                                    ${!isDeleted ? `<a href="/product/${product.url}">${product.description}</a>` : `<p>${product.description}</p>`}
                                    <div class="desc">${!isDeleted ? `Artikelnummer:  ${product.itemCode}` : 'Dit product is verwijderd'}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">${product.quantity}x</div>
                        ${!noPrice ? `<div class="col-sm-2">${priceFormat(product.totalPriceExclVat)}</div>` :''}
                    </div>
                    `.trim()}).join('')}
                    ${!noPrice ? `<div class="c-order-history__total-prices">
                        <div class="row">
                            <div class="hidden-xs col-sm-10 text-right"><strong>Totaalprijs</strong></div>
                            <div class="col-xs-12 col-sm-2">
                                <span><strong class="visible-xs">Totaalprijs</strong><strong>${totalPrice}</strong></span>
                            </div>
                        </div>
                    </div>` : ''}

                    <div class="row">
                        <div class="col-xs-12 text-right">
                            <button class="btn btn-link btn-sm" type="button" data-toggle="modal" data-target="#delete-${identifier}">
                                Project verwijderen
                            </button>
                            <button class="btn btn-primary btn-sm c-productorder__btn" type="button" data-toggle="modal" data-target="#append-${identifier}">
                                Winkelwagen toepassen
                            </button>
                        </div>
                    </div>

                    <div class="modal fade" tabindex="-1" id="delete-${identifier}" role="dialog" aria-labelledby="delete modal">
                        <div class="modal-dialog modal-sm" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">${cartName} verwijderen?</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <p>Weet je zeker dat je dit project wilt verwijderen?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuleren</button>
                                    <button type="button" class="btn btn-primary" data-cart-id="${identifier}" data-cart-name="${cartName}" data-module="deleteCart">Doorgaan</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" tabindex="-1" id="append-${identifier}" role="dialog" aria-labelledby="append modal">
                        <div class="modal-dialog modal-sm" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">${cartName} toepassen?</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <p>Door het vullen van uw winkelwagen met dit project, wordt de reeds gevulde winkelwagen verwijderd. Wilt u doorgaan?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuleren</button>
                                    <button type="button" class="btn btn-primary" data-cart-id="${identifier}" data-cart-name="${cartName}" data-module="appendCart">Doorgaan</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
`;

  return html;
}

export default savedShoppingCartTemplate;
